__turbopack_context__.v({
  "buttonIcon": "_1LmRVW_buttonIcon",
  "container": "_1LmRVW_container",
  "editButton": "_1LmRVW_editButton",
  "label": "_1LmRVW_label",
  "selectedWords": "_1LmRVW_selectedWords",
  "title": "_1LmRVW_title",
  "type": "_1LmRVW_type",
});
